<script setup lang="ts">
import { ProgressIndicator, ProgressRoot } from "reka-ui";
import { computed } from "vue";

const props = defineProps<{
  total?: number;
  current?: number;
}>();

const percentage = computed(() => {
  if (props.current == null || props.total == null) return 0;
  return props.current / props.total * 100;
});

const value = computed(() => {
  if (props.current == null) return null;
  return props.current > props.total! ? props.total : props.current;
});
</script>

<template>
  <ProgressRoot
    :model-value="value"
    :max="total"
    class="relative h-1.5 transform-gpu overflow-hidden rounded-full bg-slate-200"
  >
    <ProgressIndicator
      :style="`transform: translateX(-${100 - percentage}%)`"
      class="size-full rounded-full bg-blue-500 transition-transform duration-1000 ease-in-out data-[state=indeterminate]:animate-progress-indeterminate"
    />
  </ProgressRoot>
</template>
